<palantir-dialog [title]="title + (limit ? ' (' + attachments().length + '/' + limit + ')' : '')">
  <palantir-dialog-content
    class="palantir-scrollbar"
    [ngClass]="{ 'attachments-content--empty': attachments().length === 0 }"
  >
    <div
      #attachmentsDiv
      dropzone="copy"
      (dragover)="$event.preventDefault(); attachmentsDiv.classList.add('drag-over')"
      (dragenter)="$event.preventDefault(); attachmentsDiv.classList.add('drag-over')"
      (dragleave)="$event.preventDefault(); attachmentsDiv.classList.remove('drag-over')"
      (drop)="handleDropFile($event)"
      class="drop-attachments-area"
    >
      <input type="file" multiple hidden #fileInput (change)="handleFileSelect($event)" />
      <div class="drop-attachments-area__text">
        <palantir-icon class="drop-attachments-area__text__icon" name="upload" size="large" />
        <palantir-text type="primary-bold">{{ dropArea.primaryText }}</palantir-text>
      </div>
      <palantir-text type="description">{{ dropArea.secondaryText }}</palantir-text>
      <palantir-button theme="outline" (click)="fileInput.click()">{{
        dropArea.button
      }}</palantir-button>
    </div>
    <palantir-text type="description">{{ text }}</palantir-text>

    <div
      class="attachments-display"
      [ngClass]="{
        'attachments-display--empty': attachments().length === 0 || files().length === 0,
      }"
    >
      @for (attachmentSkeleton of files(); track attachmentSkeleton) {
        <div class="attachment-skeleton">
          <div class="skeleton"></div>
        </div>
      }

      @for (attachment of attachments(); track attachment; let index = $index) {
        <div @fadeInOut class="attachment-preview">
          <div
            class="attachment-preview__without-image"
            (click)="removeAttachment($event, index)"
            (keydown.enter)="removeAttachment($event, index)"
            tabindex="0"
          >
            <palantir-icon name="close-outline" class="attachment-preview__without-image__icon" />
          </div>

          @if (imageExtensions.includes(attachment.extension)) {
            @if (attachment.thumb) {
              <img
                appImageLoad
                class="attachment-preview__image"
                [src]="attachment.thumb"
                [palantirTooltip]="attachment.filename"
                [alt]="attachment.filename"
              />
            }
            @if (!attachment.thumb) {
              <div class="attachment-card">
                <palantir-icon name="picture" class="attachment-card--picture" />
              </div>
            }
          }

          @if (videoExtensions.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="video-outline" class="attachment-card--video" />
            </div>
          }

          @if (audioExtensions.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="audio-file-outline" class="attachment-card--audio" />
            </div>
          }

          @if (attachment.extension === 'pdf') {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="pdf" class="attachment-card--pdf" />
            </div>
          }

          @if (documentExtensions.word.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="doc" class="attachment-card--doc" />
            </div>
          }

          @if (documentExtensions.excel.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="excel" class="attachment-card--excel" />
            </div>
          }

          @if (documentExtensions.presentation.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="slide" class="attachment-card--slide" />
            </div>
          }

          @if (attachment.extension === 'csv') {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="csv" class="attachment-card--csv" />
            </div>
          }

          @if (documentExtensions.text.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="txt" class="attachment-card--txt" />
            </div>
          }

          @if (cadExtensions.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="design-outline" class="attachment-card--cad" />
            </div>
          }

          @if (archiveExtensions.includes(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="archive-outline" class="attachment-card--archive" />
            </div>
          }

          @if (!allExtensions.has(attachment.extension)) {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="code-file-filled" class="attachment-card--default" />
            </div>
          }

          @if (attachment.extension === 'kml') {
            <div class="attachment-card" [palantirTooltip]="attachment.filename">
              <palantir-icon name="code-outline" class="attachment-card--txt" />
            </div>
          }
        </div>
      }
    </div>
  </palantir-dialog-content>

  <palantir-dialog-actions>
    @if (cancelText) {
      <palantir-button theme="outline" (click)="close()">{{ cancelText }}</palantir-button>
    }
    <palantir-button [attr.disabled]="!attachments().length" (click)="confirm()">{{
      successText
    }}</palantir-button>
  </palantir-dialog-actions>
</palantir-dialog>
